import React from 'react';
import Button from './Button';
import { READING_WORDING as RW } from '../domain/reading';
import { retryFailedReads } from '../data/readRetry';
import e from './EmptyState.module.css';
import s from './ReadFailed.module.css';

// What a screen shows where its list would be when the read stopped before
// it answered (#647): what the device saw, the two causes it cannot tell
// apart, and Try again — which starts every failed read over
// (src/data/readRetry.js).
//
// The block form is an empty state's shape, so it sits where one would; the
// inline form (`inline`) stands in a table cell or beside a one-line hint.
export default function ReadFailed({ inline = false }) {
  if (inline) {
    return (
      <span className={s.inline} role="alert">
        <span>{RW.failedTitle}.</span>
        <Button variant="secondary" size="sm" onClick={retryFailedReads}>{RW.retry}</Button>
      </span>
    );
  }
  return (
    <div className={e.empty} role="alert">
      <div className={e.title}>{RW.failedTitle}</div>
      <div className={e.desc}>{RW.failedDescription}</div>
      <div className={e.actions}>
        <Button variant="secondary" onClick={retryFailedReads}>{RW.retry}</Button>
      </div>
    </div>
  );
}
